/**
 * @author: dongjing
 * @file: description
 * @Date: 2020-01-06 14:29:02
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-05-06 17:08:25
 */
/**
 * @file
 *
 * @authors zhengmeiyu (zhengmeiyu@kuaishou.com)
 * @date    2019-08-22 11:03:46
 * @version 1.0.0
 */

import React from 'react';

export interface ISFCFooterProps {
  /** 显示还是隐藏 */
  hidden?: boolean;
}

import { TO_YEWAR, TITLE } from '@src/utils/constant/common';
import LOGO from '@src/assets/LOGO.png';
import './SFCFooter.less';

export const SFCFooter: React.SFC<ISFCFooterProps> = (props: ISFCFooterProps) => {
  const { hidden = false } = props;
  return (
    <div className={hidden ? 'k-tech-com-footer hidden' : 'k-tech-com-footer '}>
      <div className="top">
        <div className="logo">
          <img src={LOGO} />
        </div>
        <div className="left">
          <div className="item help">
            <div className="title">关于我们</div>
            <a className="desc center" href="https://university.kuaishou.com/juxing/index">
              快手达人生态营销平台 让内容和生意一拍即合
            </a>
          </div>
          <div className="item contact">
            <div className="title">联系我们</div>
            <span className="desc mail">kjd-kol@kuaishou.com</span>
          </div>
          <div className="item friend-url">
            <div className="title">相关链接</div>
            <a
              className="desc center"
              target="_blank"
              rel="noopener noreferrer"
              href="https://live.kuaishou.com/profile/chenzhongkeji?fid=1882509053&cc=share_copylink&followRefer=151&shareMethod=TOKEN&kpn=KUAISHOU&subBiz=PROFILE&shareId=6557669715406&shareToken=X4USI7oUBnHf1t6_A&shareMode=APP&originShareId=6557669715406&appType=1&shareObjectId=665149218&shareUrlOpened=0"
            >
              磁力聚星官方助手
            </a>
            <a className="desc center" href="https://k.kuaishou.com/official.html#/">
              磁力聚星官方网址
            </a>
          </div>
        </div>
        <div className="right"></div>
      </div>
      <div className="bottom">
        Copyright © {TO_YEWAR} {TITLE} All Rights Reserved
      </div>
    </div>
  );
};

export default React.memo(SFCFooter);
